// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_aW6","cls2":"DownloadOptionCard-cls2_m3X DownloadOptionCard-cls1_aW6"};